import cross from './images/cross.png';
import edit from './images/st5.png';
import axios from "axios";
import { useEffect, useState } from "react";
import SideBar from './sidebar';
function Clients()
{
    let [formdata,setFormdata]=useState({cid:"",cname:"",address:"",country:"",state:"",city:"",pincode:"",contact:"",contactno:"",gstin:""});
    let [cntries,setCntries]=useState([]);
    let [states,setStates]=useState([]);
    let [vendors,setClients]=useState([]);
    function clearText()
    {
        setFormdata({cid:"",cname:"",address:"",country:"",state:"",city:"",pincode:"",contact:"",contactno:"",gstin:""});
    }
    function getCountries(event)
    {
        let config={headers:{"Content-Type":"application/json",}};
        axios.get(process.env.REACT_APP_APIURL+"countries.php").then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                setCntries(reply.data.data);
            }
        });
    }
    async function getStates(cname)
    {
        let config={headers:{"Content-Type":"application/json",}};
        await axios.get(process.env.REACT_APP_APIURL+"countries.php?cname="+cname).then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                setStates(reply.data.data);
            }
        });
    }    
    function doDataChange(event)
    {
        if(event.target.id=="cname")
            setFormdata({...formdata,cname:event.target.value});
        else if(event.target.id=="address")
            setFormdata({...formdata,address:event.target.value});
        else if(event.target.id=="country")
        {
            setFormdata({...formdata,country:event.target.value});
            getStates(event.target.value);
        }
        else if(event.target.id=="state")
            setFormdata({...formdata,state:event.target.value});
        else if(event.target.id=="city")
            setFormdata({...formdata,city:event.target.value});
        else if(event.target.id=="pincode")
            setFormdata({...formdata,pincode:event.target.value});
        else if(event.target.id=="contact")
            setFormdata({...formdata,contact:event.target.value});
        else if(event.target.id=="contactno")
            setFormdata({...formdata,contactno:event.target.value});
        else if(event.target.id=="gstin")
            setFormdata({...formdata,gstin:event.target.value});
    }
    function saveData(event)
    {
        event.preventDefault();
        let json=JSON.stringify(formdata);   
        let config={headers:{"Content-Type":"application/json",}};
        if(formdata.cid=="" || formdata.cid=="0")
        {
            axios.post(process.env.REACT_APP_APIURL+"clients.php?opr=S",json).then(reply=>
            {
                if(reply.status==200 && reply.data.status=="OK")
                {
                    alert(reply.data.message);
                    clearText();
                    getClients();
                }
                else
                {
                    alert(reply.data.message);
                }
            });
        }
        else
        {
            axios.post(process.env.REACT_APP_APIURL+"clients.php?opr=U",json).then(reply=>
            {
                if(reply.status==200 && reply.data.status=="OK")
                {
                    alert(reply.data.message);
                    clearText();
                    getClients();
                }
                else
                {
                    alert(reply.data.message);
                }
            });
        }
    }
    function doEdit(id)
    {
        let config={headers:{"Content-Type":"application/json",}};
        axios.get(process.env.REACT_APP_APIURL+"clients.php?cid="+id).then(reply=>
        {
            if(reply.status==200 && reply.data.status=="OK")
            {
                getStates(reply.data.data.country);                
                setFormdata(reply.data.data);

            }
        });
    }
    function doDelete(id)
    {
        if(window.urole.toUpperCase()!="ADMINISTRATOR")
        {
            alert("Sorry!, You can't delete!!!!");
            return;
        }
        if(window.confirm('Are you sure?'))
        {
            let json=JSON.stringify({cid:id});
            let config={headers:{"Content-Type":"application/json",}};
            axios.post(process.env.REACT_APP_APIURL+"clients.php?opr=D",json).then(reply=>
            {
                if(reply.status==200 && reply.data.status=="OK")
                {
                    alert(reply.data.message);
                    clearText();
                    getClients();
                }
                else
                {
                    alert(reply.data.message);
                }
            });
        }
    }
    function getClients()
    {
        let config={headers:{"Content-Type":"application/json",}};
        axios.get(process.env.REACT_APP_APIURL+"clients.php").then(reply=>
            {
                if(reply.status==200 && reply.data.status=="OK")
                {
                    setClients(reply.data.data);
                }
            });
    }
    useEffect(()=>{
        getCountries();
        getClients();
    },[])
    return(
        
        <div className="container">
            <div className="mt-3">
                <form onSubmit={saveData}>
                    <div className="card shadow">
                        <div className="card-header text-center bg-warning text-dark h5">Client Details</div>
                        <div className="card-body">
                            <input type="hidden" value={formdata.cid} id="cid" />
                            <div className="row">
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12">
                                    <label>Company Name</label>
                                    <input type="text" onChange={doDataChange} value={formdata.cname} id="cname" className="form-control form-control-sm" required />
                                </div>
                                <div className="form-group col-xxl-8 col-xl-8 col-lg-8 col-md-8 col-12">
                                    <label>Address</label>
                                    <input type="text" onChange={doDataChange} value={formdata.address} id="address" className="form-control form-control-sm" required />
                                </div>
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12">
                                    <label>Country</label>
                                    <select onChange={doDataChange} id="country" className="form-control form-control-sm" required>
                                        {cntries.map((e,i)=>
                                            <option value={e.country} selected={e.country==formdata.country}>{e.country}</option>
                                        )}
                                    </select>
                                </div>
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12">
                                    <label>State</label>
                                    <select onChange={doDataChange} id="state" className="form-control form-control-sm" required>
                                        {states.map((e,i)=>
                                            <option value={e.state} selected={e.state==formdata.state}>{e.state}</option>
                                        )}
                                    </select>
                                </div>
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12" required>
                                    <label>City</label>
                                    <input type="text" onChange={doDataChange} value={formdata.city} id="city" className="form-control form-control-sm" />                                        
                                </div>
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12">
                                    <label>Pin Code</label>
                                    <input  onChange={doDataChange} id="pincode" type="text" value={formdata.pincode} className="form-control form-control-sm" required />
                                </div>                                
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12">
                                    <label>Contact Person</label>
                                    <input onChange={doDataChange} id="contact" type="text" value={formdata.contact} className="form-control form-control-sm" required />
                                </div>
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12">
                                    <label>Contact No</label>
                                    <input onChange={doDataChange} id="contactno" type="text" value={formdata.contactno} className="form-control form-control-sm" required />
                                </div>
                                <div className="form-group col-xxl-4 col-xl-4 col-lg-4 col-md-6 col-12">
                                    <label>GSTIN</label>
                                    <input onChange={doDataChange} id="gstin" type="text" value={formdata.gstin} className="form-control form-control-sm" required />
                                </div>
                            </div>
                            <input type="submit" value="Add/Update Client" className="btn bg-warning text-black mt-3" />
                            <input type="button" onClick={clearText} value="Clear" className="btn bg-info text-black mt-3 ms-3" />
                            <hr/>
                            <div style={{overflow:'auto',fontSize:'12px'}}>
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>S.No.</th>
                                            <th>Client Name</th>
                                            <th>Address</th>
                                            <th>Country</th>
                                            <th>State</th>
                                            <th>City</th>
                                            <th>Pin Code</th>
                                            <th>Contact Person</th>
                                            <th>Contact No</th>
                                            <th className='text-success'>Project Completed</th>                                        
                                            <th className='text-info'>Project Running</th>                                        
                                            <th className='text-danger'>Project Delayed</th>                                        
                                            <th></th>
                                            <th></th>                                        
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {vendors.map((e,i)=>
                                            <tr>
                                                <td>{i+1}</td>
                                                <td>{e.cname}</td>
                                                <td>{e.address}</td>
                                                <td>{e.country}</td>
                                                <td>{e.state}</td>
                                                <td>{e.city}</td>
                                                <td>{e.pincode}</td>
                                                <td>{e.contact}</td>
                                                <td>{e.contactno}</td>    
                                                <td className='text-success'>{e.completed}</td>                                            
                                                <td className='text-info'>{e.running}</td>                                            
                                                <td className='text-danger'>{e.delayed}</td>                                            
                                                <td><img src={edit} width="25px" style={{cursor:'pointer'}} onClick={()=>{doEdit(e.cid);}} /></td>
                                                <td><img src={cross} width="25px" style={{cursor:'pointer'}} onClick={()=>{doDelete(e.cid);}} /></td>
                                            </tr>
                                        )}                                            
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="card-footer bg-warning"></div>
                    </div>
                </form>
            </div>
        </div>
        
    );
}
export default Clients;